import React from 'react';
import { NavLink } from 'react-router-dom';

const Menu = () => {
  return (
    <div className="container">
      <ul className='header-menu'>
        <li><NavLink className="menu-item" exact to='/'>Home</NavLink></li>
        <li><NavLink className="menu-item" to='/promo'>Promo</NavLink></li>
        <li><NavLink className="menu-item" to='/bestseller'>Terlaris</NavLink></li>
        <li><NavLink className="menu-item" to='/help'>Pusat Bantuan</NavLink></li>
        <li><NavLink className="menu-item" to='/contact'>Hubungi Kami</NavLink></li>
      </ul>
    </div>
  )
}

export default Menu
